// University of Kansas undergraduate majors (#2840). Read on 2026-10-01
// from the official 2026-2027 Academic Catalog (catalog.ku.edu): its A-Z
// index lists every program by its full degree title and links it under the
// school that offers it. Every "Bachelor of ..." entry is kept; the 24
// "Bachelor of Music with concentration in ..." entries are concentrations
// of the one Bachelor of Music and are left out, as are minors,
// certificates, accelerated BA/MA tracks and graduate programs. A title
// such as "Bachelor of Arts and Bachelor of General Studies in History"
// appears once per degree. Degrees are written out as the catalog writes
// them ("Bachelor of Science in Business", "Bachelor of Science in
// Education"), without the major name. The catalog lists the School of the
// Arts and Public Affairs and Administration as parts of the College of
// Liberal Arts and Sciences; they keep their own groups here. The online
// Bachelor of Business Administration's note quotes KU's Major-Specific
// Admission Requirements page. The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "university-of-kansas",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree in KU's official 2026-2027 Academic Catalog, grouped by the school that offers it, with the degree it leads to. Concentrations, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "KU Academic Catalog 2026-2027, College of Liberal Arts and Sciences",
                "url": "https://catalog.ku.edu/liberal-arts-sciences/"
            },
            "majors": [
                {
                    "name": "African and African-American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "African and African-American Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "American Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Applied Behavioral Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Applied Behavioral Science",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Astronomy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Astronomy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Classics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classics",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Ecology, Evolution, and Organismal Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Ecology, Evolution, and Organismal Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "French, Francophone and Italian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Global and International Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Health and Society",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Health and Society",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "History of Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History of Art",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Human Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Human Sexuality",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Human Sexuality",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Intelligence and National Security Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Intelligence and National Security Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Liberal Arts and Sciences",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Literature, Language, and Writing",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Literature, Language, and Writing",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Molecular, Cellular, and Developmental Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Molecular, Cellular, and Developmental Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Religious Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Slavic, German, and Eurasian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Spanish",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Speech-Language-Hearing",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Speech-Language-Hearing",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "Bachelor of General Studies"
                }
            ]
        },
        {
            "name": "Public Affairs and Administration (in the College of Liberal Arts and Sciences)",
            "source": {
                "label": "KU Academic Catalog 2026-2027, Public Affairs and Administration",
                "url": "https://catalog.ku.edu/public-affairs-administration/"
            },
            "majors": [
                {
                    "name": "Law and Society",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Law and Society",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Public Administration",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Administration",
                    "degree": "Bachelor of General Studies"
                }
            ]
        },
        {
            "name": "School of Architecture and Design",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Architecture and Design",
                "url": "https://catalog.ku.edu/architecture/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Business",
                "url": "https://catalog.ku.edu/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Business Administration",
                    "note": "Online, for students who have completed at least 60 college hours"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Business Analytics",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Information Systems",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Management and Leadership",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "Bachelor of Science in Business"
                }
            ]
        },
        {
            "name": "School of Education and Human Sciences",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Education and Human Sciences",
                "url": "https://catalog.ku.edu/education/"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Exercise Science",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Exercise Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Secondary Education",
                    "degree": "Bachelor of Science in Education"
                },
                {
                    "name": "Sport Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Unified Early Childhood",
                    "degree": "Bachelor of Science in Education"
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Engineering",
                "url": "https://catalog.ku.edu/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied Computing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Health Professions",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Health Professions",
                "url": "https://catalog.ku.edu/health-professions/"
            },
            "majors": [
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Diagnostic Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Information Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Respiratory Care",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Journalism and Mass Communications",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Journalism and Mass Communications",
                "url": "https://catalog.ku.edu/journalism-mass-communications/"
            },
            "majors": [
                {
                    "name": "Journalism and Mass Communications",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Music",
                "url": "https://catalog.ku.edu/music/"
            },
            "majors": [
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music Education"
                },
                {
                    "name": "Music Therapy",
                    "degree": "Bachelor of Music Therapy"
                },
                {
                    "name": "Theatre and Voice",
                    "degree": "Bachelor of Fine Arts"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Nursing",
                "url": "https://catalog.ku.edu/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Pharmacy",
                "url": "https://catalog.ku.edu/pharmacy/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Professional Studies",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Professional Studies",
                "url": "https://catalog.ku.edu/professional-studies/"
            },
            "majors": [
                {
                    "name": "American Sign Language and Deaf Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "American Sign Language and Deaf Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Applied Cybersecurity",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Biotechnology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Sciences",
                    "degree": "Bachelor of Health Sciences"
                },
                {
                    "name": "Information Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Nutrition",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Operations Management",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Professional Performance",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Professional Studies",
                    "degree": "Bachelor of Professional Studies"
                },
                {
                    "name": "Project Management",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Project Management",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Social Welfare",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of Social Welfare",
                "url": "https://catalog.ku.edu/social-welfare/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                }
            ]
        },
        {
            "name": "School of the Arts (in the College of Liberal Arts and Sciences)",
            "source": {
                "label": "KU Academic Catalog 2026-2027, School of the Arts",
                "url": "https://catalog.ku.edu/arts/"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "History of Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of General Studies"
                },
                {
                    "name": "Theatre Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Visual Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Visual Art",
                    "degree": "Bachelor of Fine Arts"
                }
            ]
        }
    ]
};

export default majors;
